import { inlinedQrl, useLexicalScope } from "@builder.io/qwik";
import { evaluate } from "./evaluate/evaluate.qwik.mjs";
function createEventHandler(value, options) {
  return /* @__PURE__ */ inlinedQrl((event) => {
    const [options2, value2] = useLexicalScope();
    return evaluate({
      code: value2,
      context: options2.context,
      localState: options2.localState,
      rootState: options2.rootState,
      rootSetState: options2.rootSetState,
      event
    });
  }, "createEventHandler_7wCAiJVliNE", [
    options,
    value
  ]);
}
export {
  createEventHandler
};
